// NewsCard.jsx
import React from 'react';
import styles from './../style/News.module.scss';

const NewsCard = ({ newsItem }) => {
  return (
    <a href={newsItem.link} className={styles.newsCard}>
      <div className={styles.newsImageWrapper}>
        {newsItem.photo ? (
          <img 
            src={newsItem.photo} 
            alt={newsItem.name} 
            className={styles.newsImage}
          />
        ) : (
          <div className={styles.newsImagePlaceholder}></div>
        )}
      </div>
      <div className={styles.newsContent}>
        <h3 className={styles.newsTitle}>{newsItem.name}</h3>
        <p className={styles.newsText}>{newsItem.text}</p>
        <div className={styles.newsDate}>{newsItem.date}</div>
      </div>
    </a>
  );
};

export default NewsCard;